import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchOrders } from '../api/orders.api';

export const useOrders = (filters: unknown) =>
  useQuery({
    queryKey: ['orders', filters],
    queryFn: () => fetchOrders(filters),
    placeholderData: keepPreviousData,
  });
